<template>
	<div style="overflow:hidden;">
		<div class="header">
			<form>
				<van-search placeholder="请输入搜索关键词" v-model="keywords" show-action @search="onSearch(keywords)"
					@cancel="onCancel"/>
			</form>
			<van-cell :span="24" title="搜索历史" v-if="history.length>0">
				<van-icon name="cross" slot="right-icon" style="line-height: inherit;" @click="clearHistory"/>
			</van-cell>
			<van-cell>
				<van-tag plain size="large" v-for="(item,index) in history" :key="index" @click="onSearch(item)">{{item}}</van-tag>
			</van-cell>	
		</div>
		
		<van-list :style="history.length>0?'margin-top:153px;':'margin-top:73px;'" v-if="list.length>0" v-model="loading" :finished="finished" finished-text="没有更多了" :error.sync="error" error-text="请求失败，点击重新加载" @load="onLoad">
			<van-cell v-for="(item,index) in list" :key="index">
				<a :href="item.biaoqian=='专题' ? item.Url : '/#/detail/'+item.tid">
				<van-col :span="24">
					<span class="title">{{ item.title}}</span>
				</van-col>
				<van-col :span="24" class="news">
					<span>{{ item.PublishTime|moment("from","now",true)}}</span> 
					<span>{{ item.ClassCn}} | </span>
				</van-col>
				</a>
			</van-cell>
		</van-list>
		<div :style="history.length>0?'margin-top:153px;':'margin-top:73px;'"  class="no_content"  v-if="is_content">
			没有内容
		</div>
	</div>
</template>
<script>
	import Vue from 'vue';
import { isNull } from 'util';
	const moment = require('moment')
	require('moment/locale/zh-cn')
	Vue.use(require('vue-moment'), {
	    moment
	})
	Vue.moment().locale();
	import {Dialog} from 'vant';
	export default{
		data(){
			return {
				keywords:'',
				list:[],
				loading:false,
				finished:false,
				error:false,
				page:1,
				history:[],
				is_content:false,
        appid:0
			}
		},
		mounted() {
		  this.appid = localStorage.getItem('appid')
			this.history = JSON.parse(localStorage.getItem('history'));
			if(isNull(this.history)){
				this.history=[];
			}
		},
		methods:{
			onSearch(keywords){
				if(keywords!=''){
					if(keywords.trim()){
						this.list = [];
						this.page=1;
						if(this.history.indexOf(keywords)<0){
							this.history.push(keywords);
							localStorage.setItem('history',JSON.stringify(this.history));
						}
						
						this.keywords = keywords;
						this.finished = false;
						this.onLoad();
					}
				}
			},
			onLoad(){
				if(this.keywords!=''){
					this.loading=true;
					this.fetchData();
				}
			},
      toHome(){
         this.$router.push('/')
      },
			fetchData(){
				this.$http.get(this.baseUrl+'/v1/news/search?appid='+this.appid+'&keyword='+this.keywords+'&page='+this.page).then((res)=>{
					if(res.data.statecode==1){
              if(res.data.data.data.length == 0&&this.page == 1){
                this.is_content = true;
              }else{
                this.is_content = false;
              }
              if(res.data.data.data.length>0){
                res.data.data.data.forEach(function(item,index){
                  this.list.push(item);
                },this);
                this.loading=false;
                this.page = this.page+1;
              }else{
                this.loading=false;
                this.finished=true
              }
					}else{
						this.loading=false;
						this.error = true;
						Dialog.alert({message:res.data.message}).then(()=>{
						    this.toHome()
            })
					}
					
				});
			},
			onCancel(){
				this.$router.go(-1);
			},
			clearHistory(){
				this.history = [];
				localStorage.removeItem('history');
			}
		},
	}
</script>

<style>
a{
	color: #000000;
}
.header{
	position:fixed;
	z-index:1;
	width: 100%;
}
.title{
		font-size: 16Px;
		font-weight: 700;
		line-height: 20Px;
	}
.news span{
		float: right;
		font-size: 14Px;
		color: #aaa;
		padding:0 5Px;
		
}
.van-tag{
	margin:5Px 5Px;
}
.no_content{
	color: #969799;
	font-size: 14Px;
	line-height: 50Px;
	text-align: center;
}
</style>
